// extracted by mini-css-extract-plugin
export default {"ThankYouStep":"styles_ThankYouStep__KHbYG"};